<template>
  <div class="Banner wow bounceInDown">
    <div class="swiper-container" v-swiper:pageBannerSwiper="swiperOption">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="bannerImg">
            <div class="cont_lable">
              <img
                class="img_logo wow bounceIn"
                data-wow-duration="3s"
                data-wow-delay="1s"
                src="../../assets/img/common/page_logo.png"
                alt="..."
              />
            </div>

            <img class="banner_bg" :src="bannerObj.bannerImg" alt="banner" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Swiper from "swiper";
export default {
  name: "pageBanner",
  props: ["bannerObj"],
  data() {
    return {
      swiperOption: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoResize: true,
        watchActiveIndex: true,
        lazyLoading: true, // 图片懒加载
        lazyLoadingInPrevNext: true,
        preventLinksPropagation: false,
        preventClicks: false,
        visibilityFullFit: true,
        updateOnImagesReady: true, // 所有内部图像（<img>标签）装入后重新初始化Swipe
        calculateHeight: true, // 当值为true时，
        autoplay: 3000,
      },
    };
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
    // new Swiper(".swiper-container", {
    //   observer: true, //修改swiper自己或子元素时，自动初始化swiper
    //   observeParents: true, //修改swiper的父元素时，自动初始化swiper
    //   autoResize: true,
    //   watchActiveIndex: true,
    //   lazyLoading: true, // 图片懒加载
    //   lazyLoadingInPrevNext: true,
    //   preventLinksPropagation: false,
    //   preventClicks: false,
    //   visibilityFullFit: true,
    //   updateOnImagesReady: true, // 所有内部图像（<img>标签）装入后重新初始化Swipe
    //   calculateHeight: true, // 当值为true时，
    // });
  },
};
</script>

<style lang="scss" scoped>
$minWidth: 1180px;
$minHeight: 400px;
.Banner {
  width: 100%;
  min-width: $minWidth;
  position: relative;
  /deep/ .bannerImg {
    width: 100%;
    min-height: $minHeight;
    min-width: $minWidth;
    position: relative;
    .banner_bg {
      display: block;
      width: 100%;
      min-height: $minHeight;
      object-fit: cover;
    }
  }

  .cont_lable {
    width: 710px;
    height: 110;
    position: absolute;
    top: 90px;
    left: 50%;
    z-index: 6;
    transform: translate(-50%, 0);
    color: #ffffff;
    img {
      display: block;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
